module.exports = __webpack_public_path__ + "static/media/icon-sales-won-white.4fb5ae35.svg";